var React = require('react');

function FeedIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_22","data-name":"Path 22","d":"M935.909,385.784a.987.987,0,0,0-.987.987v21.61l6.565-6.565h15.044a.987.987,0,0,0,.988-.987V386.771a.987.987,0,0,0-.988-.987Z","transform":"translate(-934.922 -385.784)"}));
}

FeedIcon.defaultProps = {"width":"22.597","height":"22.597","viewBox":"0 0 22.597 22.597"};

module.exports = FeedIcon;

FeedIcon.default = FeedIcon;
